import { container } from 'tsyringe';
import { useEffect, useState } from 'react';
import { useBehaviorSubject } from '@base/utils/helpers';
import { IPlayersOnlineRepository } from '@base/features/player/model/interfaces';
import { ITicketService } from '@base/features/tickets/model/interfaces';

export const useAdsBanner = () => {
  const playersOnlineRepository: IPlayersOnlineRepository = container.resolve('playersOnlineRepository');
  const me = playersOnlineRepository.me;
  const [isTicketsPlayer, setIsTicketsPlayer] = useState(true);
  const ticketService: ITicketService = container.resolve('ticketsService');
  const tickets = useBehaviorSubject(ticketService.accountBalance);

  useEffect(() => {
    if (me) {
      setIsTicketsPlayer(Boolean(me.isTicketPlayer()));
    } else if (tickets) {
      setIsTicketsPlayer(Boolean(tickets));
    }
  }, [me, tickets]);

  return isTicketsPlayer;
};
